import Vue from 'vue'
import Router from 'vue-router'
import Main from './main'
import Patient from './patient'
import Caregiver from './caregiver'
import Connection from './connection'
import Device from './device'

import { getToken } from '@/util/auth.js'
import { getServerStatus as GET_SERVER_STATUS } from '@/api/misc.js'

import store from '@/stores'

Vue.use(Router)

var router = new Router({
  mode: 'history',
  base: process.env.VUE_APP_ASSETS_PUBLIC_PATH ? process.env.VUE_APP_ASSETS_PUBLIC_PATH : '/',
  routes: [
    ...Main,
    ...Patient,
    ...Connection,
    ...Caregiver,
    ...Device
  ]
})

router.beforeEach(async (to, from, next) => {
  const USER_TOKEN = getToken()
  document.title = (to.meta.title != null)
    ? to.meta.title + ' - KNEESUP Med'
    : 'KNEESUP Med'

  // TESTME: 是不是可以不用
  if (to.meta.requireAuth == null) return next()

  // 路由需要效驗 且 沒有登入
  if (to.meta.requireAuth && !USER_TOKEN) {
    console.log('Will redirect to Login page, [from]:', from)
    return next({ name: 'login' })
  }

  // 路由不需要效驗 且 已登入
  if (!to.meta.requireAuth && USER_TOKEN) {
    return next({ name: 'home' })
  }

  if (!to.meta.requireAuth) {
    await GET_SERVER_STATUS()
  }

  // 不支援手機版的頁面 需要彈出窗提示
  const phoneBreakPoint = store.getters['system/getPhoneBreakPoint']
  const screenWidth = window.innerWidth
  if (screenWidth < phoneBreakPoint && !to.meta.isSupportMobile) {
    setTimeout(() => store.commit('system/SHOW_MOBILE_NOTIFICATION'), 2000)
  } else {
    store.commit('system/CLOSE_MOBILE_SIMPLE_NOTIFICATION')
  }

  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js